module.exports = __webpack_public_path__ + "img/image-collection-sliding-overlays-hyundai.23d9ebf3.png";